import { LoadState } from "../../constants/enums";
import { IOptionalFee } from "./optionaltype";



export const defaultOptionalFee: IOptionalFee = {
    fee_structure_id: 0,
    fee_structure_unique_id: 0,
    fee_structure_uuid:"",
    organizations_uuid: "",
    organizations_name: "",
    courses_uuid: "",
    courses_name: "",
    batch: "",
    academic_year: "",
    fee_type: "",
    is_optional: true,
    is_changable: true,
    fee_amount: "",
    start_date: null,
    due_date: "",
    next_run_date: "",
    notice_period: 0,
    fine_type: "",
    fine_percentage: "",
    fee_description: "",
    created_by_uuid: "",
    created_by_name: "",
    modified_by_uuid: "",
    modified_by_name: "",
    create_ts: "",
    insert_ts: ""
  };

export const defaultOptionalFeeState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  single: {
    data: defaultOptionalFee,
    loading: LoadState.NotLoaded,
    error: null,
  }
};                      

// export const defaultOptionalFee: IOptionalFee = {
//     fee_structure_id: 0,
//     fee_structure_unique_id: 0,
//     fee_structure_uuid:"",
//     organizations_uuid: "",
//     organizations_name: "",
//     courses_uuid: "",
//     courses_name: "",
//     batch: "",
//     academic_year: "",
//     fee_type: "",
//     is_optional: true,
//     is_changable: true,
//     fee_amount: "",
//     start_date: null,
//     due_date: "",
//     next_run_date: "",
//     notice_period: 0,
//     fine_type: "",
//     fine_percentage: "",
//     fee_description: "",
//     created_by_uuid: "",
//     created_by_name: "",
//     modified_by_uuid: "",
//     modified_by_name: "",
//     create_ts: "",
//     insert_ts: ""
//   };